

<div id="nonexistentJobsModal" style="display:none; position:fixed; z-index:1000; left:0; top:0; width:100%; height:100%; overflow:auto; background-color:rgba(0,0,0,0.75);">
  <div style="background-color: #ffffff;
  margin: 25% auto;
  padding: 2em;
  border: 1px solid #888;
  width: 80%;
  max-width: 300px;
  border-radius: 1em;">
    <p style="color: #424242;font-weight: 600;">Jobs not found: </p>

    <div *ngFor="let obj of nonexisting_jobs">
     <p>{{obj.job_name}}</p>
    </div>

    <button style="border: 0;margin-right: 2em;background: #8cc63f;color: white;width: 4em;" (click)="closeNonExistingModal()">OK</button>
  </div>
</div>

<div style="height:100%">
<div class = "titleBox"> <h1 style="text-align: center">Locations</h1></div>
<div><hr></div>
<br>
<br>
<button mat-raised-button class="buttonAddNew" style="    margin-left: 0px;
box-shadow: none;
border: 0;
background: #f0fdff;"  (click)="addDialog()">New <fa-icon [icon]="fahome" style="margin-right: 5px;"></fa-icon>+</button>
<button mat-raised-button class="buttonAddNew" style="    margin-left: 10px;
box-shadow: none;
border: 0;
background: #f0fdff;"  (click)="addUtilityDialog()">Add Utility</button>

<span *ngIf="allLoaded$ | async" class="fadeText" style="margin-left: 40px;color:#8cc63f;">All Locations Loaded</span>
<span *ngIf = "!(allLoaded$ | async)" class="fadeTextBlink" style="color: #8b9394;margin-left: 40px;">Loading all locations...</span>

<div style="display: flex;">
<div class='my-alternate-theme' style="width:50%">
  <h4 class="deepSearchHeader" style="font-size: 16px; margin-top: 1em;">
    <span>Deep Searches:</span>
    <button class="clearSearchButton" (click)="reset()">Clear</button>
    <select #modeSelect class="searchModeSelect" [value]="searchMode"
      (change)="onSearchModeChange(modeSelect.value)" aria-label="Search mode">
      <option value="starts" title="Matches only from the beginning of the field">Starts with</option>
      <option value="contains" title="Matches your text anywhere in the field (needs 3+ characters)">Contains</option>
      <option value="fuzzy" title="Typo-tolerant; ranked by closeness (needs 3+ characters)">Something like</option>
    </select>
  </h4>

<form [formGroup] = "form" style="margin-top: 2em;">


<div>
  <mat-form-field style="width:80%">
    <mat-label>Street Address:</mat-label>
    <input  #safilt matInput formControlName = "safilter" id="filter-address" [matAutocomplete] = "sa">
    </mat-form-field>

    <button class="miniatureButtons" mat-raised-button (click)="onSelectAddressFilterManual(safilt.value)">Go</button>

</div>


  <mat-autocomplete #sa = "matAutocomplete" (optionSelected) = "onSelectAddressFilter($event.option.value)" [displayWith]="displayFunctionSAfilter">
      <mat-option *ngFor="let address of (addresse$ | async)" [value]="address">
        <span>{{ address.street_address}}</span>
      </mat-option>
    </mat-autocomplete>


<div>
  <mat-form-field style="width:80%">

    <mat-label>Subdivision:</mat-label>
    <input  #subfilt matInput formControlName = "subfilter" id="filter-subs" [matAutocomplete] = "sub">
    </mat-form-field>

    <button class="miniatureButtons" mat-raised-button (click)="onSelectSubFilterManual(subfilt.value)">Go</button>

</div>

  <mat-autocomplete #sub = "matAutocomplete" (optionSelected) = "onSelectSubFilter($event.option.value)" [displayWith]="displayFunctionSubfilter">
      <mat-option *ngFor="let sd of (subdivision$ | async)" [value]="sd">
        <span>{{ sd.subdivision_name}}</span>
      </mat-option>
    </mat-autocomplete>

 <mat-accordion style="display: block;
 width: 80%;
 background-color: #f0fdff;">   
  <mat-expansion-panel style="background: #f0fdff;
  box-shadow: none;" (opened)="moreSearchOpened = true"
                       (closed)="moreSearchOpened = false">
    <mat-expansion-panel-header style="height: 3em;
    padding: 0px !important;">
      <mat-panel-title style="color:#8b9394;">
        More Filters
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div>
      <mat-form-field style="width:80%">
        <mat-label>Registry Id:</mat-label>
        <input  #registrationID matInput formControlName = "registeryfilter" id="filter-registery" [matAutocomplete] = "regId">
        </mat-form-field>
        <button  class="miniatureButtons" mat-raised-button (click)="onSelectRegisteryIdManual(registrationID.value)">Go</button>

    </div>
      <mat-autocomplete #regId = "matAutocomplete" (optionSelected) = "onSelectRegisteryId($event.option.value)" [displayWith]="displayFunctionRegfilter">
          <mat-option *ngFor="let obj of (registeryid$ | async)" [value]="obj">
            <span>{{ obj.registryid}}</span>
          </mat-option>
        </mat-autocomplete>

        <div>
          <mat-form-field style="width:80%">
            <mat-label>Invoice No:</mat-label>
            <input  #invoiceNo matInput formControlName = "invoicefilter" id="filter-invoice" [matAutocomplete] = "invoId">
            </mat-form-field>
            <button class="miniatureButtons" mat-raised-button (click)="onSelectInvoiceNoManual(invoiceNo.value)">Go</button>

        </div>
          <mat-autocomplete #invoId = "matAutocomplete" (optionSelected) = "onSelectInvoiceNo($event.option.value)" [displayWith]="displayFunctionInvofilter">
              <mat-option *ngFor="let obj of (invoiceno$ | async)" [value]="obj">
                <span>{{ obj.invoice_number}}</span>
              </mat-option>
            </mat-autocomplete>
            <div>
              <mat-form-field style="width:80%">
                <mat-label>PO No:</mat-label>
                <input  #poNumber matInput formControlName = "pofilter" id="filter-po" [matAutocomplete] = "poId">
                </mat-form-field>
                <button  class="miniatureButtons" mat-raised-button (click)="onSelectInvoicePoManual(poNumber.value)">Go</button>

            </div>
              <mat-autocomplete #poId = "matAutocomplete" (optionSelected) = "onSelectPoNumber($event.option.value)" [displayWith]="displayFunctionPofilter">
                  <mat-option *ngFor="let obj of (ponumber$ | async)" [value]="obj">
                    <span>{{ obj.po_number}}</span>
                  </mat-option>
                </mat-autocomplete>

        <div>
          <mat-form-field style="width:80%">
            <mat-label>Builder:</mat-label>
            <input  #builderNo matInput formControlName = "builderfilter" id="filter-builder" [matAutocomplete] = "builderID">
            </mat-form-field>
        </div>
          <mat-autocomplete #builderID = "matAutocomplete" (optionSelected) = "onSelectBuilderNo($event.option.value)" [displayWith]="displayFunctionBuilderfilter">
              <mat-option *ngFor="let obj of (builder$ | async)" [value]="obj">
                <span>{{ obj.customer_name}}</span>
              </mat-option>
            </mat-autocomplete>


        <div>
          <mat-form-field style="width:80%">
            <mat-label>Plans:</mat-label>
            <input  #planNo matInput formControlName = "planfilter" id="filter-plan" [matAutocomplete] = "planID">
            </mat-form-field>
        </div>
          <mat-autocomplete #planID = "matAutocomplete" (optionSelected) = "onSelectPlanNo($event.option.value)" [displayWith]="displayFunctionPlanfilter">
              <mat-option *ngFor="let obj of (plan$ | async)" [value]="obj">
                <span>{{ obj.plan_name}}</span>
              </mat-option>
            </mat-autocomplete>
      
    </mat-expansion-panel>
  </mat-accordion>



  </form>
</div>

<div id="csvDiv" style="width:50%">


  <div>
    <p style="color:grey; ">
      <mat-form-field style='width: 250px;'>
          <mat-select [(value)] = 'csvselected' (selectionChange)="onCsvFunctionChange()" style="font-size: 16px;">
          <mat-option value="option0" style="font-size: 16px;">CSV function </mat-option>

          <mat-optgroup label="General">
            <mat-option value="jobimport">Job Importer</mat-option>
            <mat-option value="locimport">Location Importer</mat-option>
            <mat-option value="jobupdate">Job Updater</mat-option>
            <mat-option value="premiseno">Premise Number</mat-option>
          </mat-optgroup>

          <mat-optgroup label="Meritage">
            <mat-option value="merchar">Meritage CHA</mat-option>
            <mat-option value="mercstl">Meritage CSTL</mat-option>
          </mat-optgroup>

          <mat-optgroup label="Vendor Suite">
            <mat-option value="vendorsuite">Vendor Suite</mat-option>
            <mat-option value="vendorsuite2">Vendor Suite (by Job Number)</mat-option>
          </mat-optgroup>

          <mat-optgroup label="True Homes">
            <mat-option value="truehomes" style="font-size: 16px;">True Homes Permit Report</mat-option>
            </mat-optgroup>

          <mat-optgroup label="DR Horton">
            <mat-option value="drhcinci">Cincinnati</mat-option>
            <mat-option value="drhclt">CLT</mat-option>
            <mat-option value="drhgrv">GRV</mat-option>
            <mat-option value="drhindy">INDY</mat-option>
            <mat-option value="drhknx">KNX</mat-option>
            <mat-option value="drhlou">LOU</mat-option>
            <mat-option value="drhm">Myrtle</mat-option>
            <mat-option value="drhnetn">NETN</mat-option>
            <mat-option value="drhnoog">NOOG</mat-option>
            <mat-option value="drherdu">RDU East</mat-option>
            <mat-option value="drhsrdu">RDU South</mat-option>
          </mat-optgroup>

        </mat-select>
      </mat-form-field>
      <mat-form-field *ngIf="isVendorSuiteMethod()" style="margin-left: 10px;">
        <mat-label>Market</mat-label>
        <mat-select [(value)]="vendorSuiteCustomerId" style="font-size: 16px;" required
          matTooltip="Vendor Suite files carry no market; subdivisions are matched only inside the market you pick.">
          <mat-option *ngFor="let c of uploaderCustomers" [value]="c.customer_id">{{ c.customer_name }}</mat-option>
        </mat-select>
      </mat-form-field>
      <a href="/m/csv-docs" target="_blank" rel="noopener"
         style="font-size: 12px; margin-left: 10px; color: #8bc34a; text-decoration: underline; cursor: pointer;"
         matTooltip="View documentation for each CSV uploader">
        How do these work?
      </a>
    </p>

    <input type="file" class="file-input-hdn"
          (change)="parseCSV($event, csvselected)" #fileUpload>
  </div>

  <div class="file-upload" [hidden]="csvselected == 'option0'" style="border-style: dotted; border-width: 1px; border-color: lightgray; width: max-content; margin-bottom: 10px;">

    {{updaterFilename || (vendorSuiteNeedsMarket() ? "Pick a market first." : "Select a file.")}}

      <button mat-mini-fab color="primary" class="upload-btn"
        [disabled]="vendorSuiteNeedsMarket()"
        (click)="fileUpload.click()">
        <fa-icon [icon]="fapaperclip"></fa-icon>
      </button>
  </div>

  <div style="margin-bottom: 30px;" class="load-ev">

    <!--
    <div style="width: 80%;
    padding: 1%;margin-bottom: 1em;">
      <span><label style="color: #8b9394">Customer Dropdown</label></span>
      <label  class="switch" style="float: right">
        <input type="checkbox"  (click)='toggleDropdown()'>
        <span class="slider"></span>
      </label>
    </div>
  -->

    <!--
    <div style="width: 80%;
    padding: 1%;margin-bottom: 1em;">
      <span><label style="color: #8b9394">Site Visit Required Only</label></span>
      <label class="switch" style="float: right">
        <input type="checkbox" class="loadeverything" (click)='toggleGPSFilter()'>
        <span class="slider"></span>
      </label>
    </div>
    -->
    <div>
      <mat-slide-toggle style="color: #8b9394;margin-bottom: 2em;" labelPosition="before" (change)="toggleDropdown()">
        <span>Customer Dropdown</span>
      </mat-slide-toggle>
    </div>

    <div>
      <mat-slide-toggle style="color: #8b9394;margin-bottom: 2em;" labelPosition="before" (change)="toggleNewPhotoPopup()">
        <span>Use new photo pop-up</span>
      </mat-slide-toggle>
    </div>

    <div>
      <mat-slide-toggle style="color: #8b9394;margin-bottom: 2em;" labelPosition="before" (change)="toggleGPSFilter()">
        <span>Site Visit Required Only</span>
      </mat-slide-toggle>
    </div>

    <div>
      <mat-slide-toggle style="color: #8b9394;margin-bottom: 2em;" labelPosition="before" [disabled]="isPaused" [(ngModel)]="timefunctions" >
        <span *ngIf="!isPaused">Time Functions</span>
        <span *ngIf="isPaused">Time Functions Unavailable</span>
      </mat-slide-toggle>
    </div>

    <div *ngIf="timefunctions">
        <p class="jumplink" (click)="viewTimeCard()">View Timecard</p>
    </div>


    <!--
    <button style="color: white;
    background: #3f3f3f;
    height: 50px;
    margin-left: 20px;
    border-radius: 10px;" (click)="openTagsDialog()" matTooltip="Create tags to assign to jobs">Create Tag</button>
    </div>
    -->


  </div>

</div>

</div>

<div>



      <ngx-table [configuration] = "configuration" #table [data]="location$ | async" [columns]="columns" [loadingTemplate] = "loadingTemplate" [detailsTemplate] = "details" (event)="onEvent($event)" (onPagination)="resetElevPhotos()">
          <ng-template let-row let-index="index">

            <div>
              <td>
                <div style="display: flex; flex-direction: column; align-items: center; gap: 0; padding-top: 4px;">
                    <div style="display: flex; align-items: center; gap: 2px;">
                      <button mat-icon-button (click)="openDialog(row)" matTooltip="Edit Location" style="color: #6AB545;">
                        <fa-icon [icon]="faedit"></fa-icon>
                      </button>
                      <button mat-icon-button (click)="duplicateDialog(row)" matTooltip="Duplicate Location" style="color: #757575;">
                        <fa-icon [icon]="faclone"></fa-icon>
                      </button>
                    </div>
                    <div style="display: flex; align-items: center; gap: 2px;">
                      <button mat-icon-button id="jobButton-{{index}}" (click)="onExpandPhotoEvent($event,index,1,row)" *ngIf="!toggledRows.has(index)" matTooltip="View Jobs" style="color: #F9A825;">
                        <fa-icon [icon]="fahardhat"></fa-icon>
                      </button>
                      <button mat-icon-button id="jobButton-{{index}}" (click)="onExpandPhotoEventClear($event,index,1,row)" *ngIf="toggledRows.has(index)" matTooltip="Collapse Jobs" style="color: #6AB545;">
                        <fa-icon [icon]="fahardhat"></fa-icon>
                      </button>
                      <a *ngIf="row.folderid != null" target="_blank" [href]="gotoGDrive(row)" style="line-height: 0;">
                        <button mat-icon-button matTooltip="Open Google Drive" style="color: #4FC3F7;">
                          <fa-icon [icon]="fagoogle"></fa-icon>
                        </button>
                      </a>
                      <button *ngIf="row.folderid == null" mat-icon-button (click)="addDriveFolder(row,index)" matTooltip="Create Drive Folder" style="color: #E57373;">
                        <fa-icon [icon]="fagoogle"></fa-icon>
                      </button>
                    </div>
                    <button mat-button color="primary" (click)="openJobInNewTab(row)" matTooltip="Open Jobs in New Tab" style="min-width: 0; padding: 0 4px; font-size: 12px;">
                      Jobs
                    </button>
                </div>
              </td>

            </div>

            <td style="vertical-align: middle;">
              <div style="display: flex; flex-direction: column; align-items: flex-start; padding-top: 40px;">
                <span style="font-weight: 500; color: black;">{{row.street_address}}</span>
                <div>
                  <button *ngIf = 'row.form_id' button mat-icon-button title="Open Rater Form" (click)="openJobFormLocmain(row)"><fa-icon [icon]="faclipboard" style="color: #424242"></fa-icon></button>
                  <button *ngIf = 'row.form_id' button mat-icon-button title="Job Photos" (click)="onPhotosClickLocmain(row)"><fa-icon [icon]="facamera" style="color: #424242"></fa-icon></button>
                  <button button mat-icon-button title="Get form logs" (click)="onLogClick(row,true)"><fa-icon [icon]="faScroll" style="color: #424242;"></fa-icon></button>
                </div>
              </div>
            </td>

            <td>
                <div>
                  {{row.subdivision_name}}
                </div>
            </td>

            <td>
              <div>
                {{row.lot}}
              </div>
            </td>

            <td>
              <div>
                {{row.city}}
              </div>
            </td>

            <td>
              <div>
                {{row.state}}
              </div>
            </td>

            <td>
              <div>
                {{row.region}}
              </div>
          </td>

            <td>
                <div>
                  {{row.plan_name}}
                </div>
            </td>

            <td>
              <div style="display: flex; flex-direction: column; justify-content: flex-end; height: 100%; min-height: 60px;">
                <!-- elevation photos-->

                <!--
                  <div *ngIf="row.elevfront || row.elevback || row.elevright || row.elevleft">
                      <button mat-button color="grey" id="photoButton - {{index}}" (click)="onExpandPhotoEvent($event,index,2,row)" *ngIf="!toggledRows.has(index)">
                        <fa-icon [icon]="facamera"></fa-icon>
                      </button>

                      <button mat-button color="green" id="photoButton - {{index}}" (click)="onExpandPhotoEvent($event,index,2,row)" *ngIf="toggledRows.has(index)">
                          <fa-icon [icon]="facamera"></fa-icon>
                        </button>

                    </div>

                  -->

                  <!-- drive folder-->

              <div *ngIf="row.builder_done && row.builder_initials">
                <fa-icon style="color: peru" title="Builder checklist recieved" [icon]="fabuilderchklist" (click)="showTECinfo(row)"></fa-icon>
              </div>

              <div *ngIf="row.ekotrope_id"><a [href]="gotoEko(row)" target = "_blank">
                <fa-icon style="color: lightgreen" title="View Ekotrope file" [icon]="faEko"></fa-icon>
                </a>
              </div>

              <div *ngIf="row.hvacovrd || (!row.hvacerrors && row.sbmt_dsn_id > 0) || (!row.hvacerrors && row.hvac_design_id > 0 && (!row.reviewcomplete || !row.hvacovrd))"><a (click)="openHVACModal(row, index)">
                <fa-icon style="color: grey" title="HVAC ready to be reviewed"  [icon]="fahvac"></fa-icon>
              </a></div>

              <div *ngIf="row.hvacovrd || (row.hvacerrors == false && row.sbmt_dsn_id > 0)  && row.reviewcomplete">
              <a>
                <fa-icon style="color: rgb(103, 146, 255)" title="HVAC reviewed and complete" [icon]="fahvac"></fa-icon>
              </a></div>

              <div style="display: flex; align-items: center; justify-content: flex-end; gap: 0;">
                <span class="hover-show" style="display: flex; align-items: center; gap: 0;">
                  <button mat-icon-button (click)="openFlags(row, index)" matTooltip="Quick Edit Flags">
                    <fa-icon [icon]="faflag"></fa-icon>
                  </button>
                  <button mat-icon-button color="warn" (click)="deleteLocationDialog(row)" matTooltip="Delete Location">
                    <fa-icon [icon]="fatrash"></fa-icon>
                  </button>
                  <button mat-icon-button title="Report Error" (click)="reportErrorDialog(row)" class="errorButton"><i class="fa-solid fa-circle-exclamation"></i></button>
                </span>
                <!-- Always visible + green when the location has notes; otherwise hover-only like its neighbours. -->
                <button mat-icon-button [matTooltip]="hasExtraNotes(row) ? 'Extra Notes (has notes)' : 'Extra Notes'"
                        [class.hover-show]="!hasExtraNotes(row)" [class.notes-flag]="hasExtraNotes(row)"
                        (click)="openExtraNotes(row)">
                  <fa-icon [icon]="facomments"></fa-icon>
                </button>
              </div>
              </div>
          </td>

          </ng-template>
        </ngx-table>






<ng-template #loadingTemplate>
  <td [attr.colspan]="columns.length">
    <div style= "width: 100%; text-align: center">
      <div style="display: inline-block; margin: auto; padding: 3px">
          <div class="lds-ripple"><div></div><div></div>Loading...</div>
      </div>

    </div>
  </td>
</ng-template>

<ng-template #details let-row let-index="index" >

  <div [hidden]="show ==2" class ="fade-in" style="background-color: lightgray;">

    <div style="display: flex;">
      <div><button button mat-raised-button (click)="openAddJob(row)" style="margin: 10px;font-weight: 200;font-size: 16px;">New Job</button>
        <button button mat-raised-button (click)="openAddJob(row,true)" style="margin: 10px;font-weight: 200;font-size: 16px;">Audit Job</button></div>
      <div><p style="margin-bottom: 0 !important;
        position: relative;
        top: 25%;
        font-size: 20px;">{{row.street_address}}</p></div>
    </div>

    <div style="display: flex; align-items: center;
    padding-left: 10px;">
      <div>
        <p style="font-weight: 700; font-size: 14px; margin: 0;">Scope: <span style="font-size: 18px;">{{displayScope}}</span>
          <span style="padding-left: 2em;">Pathway: <span style="font-size: 18px;">{{displayPathway}}</span></span>
          <span *ngIf="displayStories" style="padding-left: 2em;">Stories: <span style="font-size: 18px;">{{displayStories}}</span></span></p>
        <p *ngIf="displayScope2" style="font-weight: 700; font-size: 14px; margin: 0;">Scope: <span style="font-size: 18px;">{{displayScope2}}</span>
          <span style="padding-left: 2em;">Pathway: <span style="font-size: 18px;">{{displayPathway2}}</span></span></p>
        <p *ngIf="displayScope3" style="font-weight: 700; font-size: 14px; margin: 0;">Scope: <span style="font-size: 18px;">{{displayScope3}}</span>
          <span style="padding-left: 2em;">Pathway: <span style="font-size: 18px;">{{displayPathway3}}</span></span></p>
      </div>
      <div *ngIf="thermalRequired" style="padding-left:10px;"><p style="text-align: center;font-weight: 700;font-size: 14px;">Thermal Required at Final</p></div>
    </div>

    <div style="display:flex;">
      <div *ngFor="let item of jobTags" style="background: #424242;
      padding: 5px;
      color: white;
      border-radius: 5px;
      margin-right: 2px;">
        {{item.displayname}}
      </div>
    </div>

    <div style="padding: 8px 10px; display: flex; align-items: center; gap: 8px;">
      <button mat-raised-button (click)="toggleTripsView(row)" [disabled]="jobLoading$ | async"
        [style.background]="tripsView ? '#8cc63f' : '#424242'"
        [style.color]="'white'"
        style="font-weight: 200; font-size: 14px;"
        [title]="tripsView ? 'Viewing trips - click to show jobs' : 'Viewing jobs - click to show trips'">
        {{ tripsView ? 'Show Jobs' : 'Show Trips' }}
      </button>
      <span style="font-size: 14px; opacity: 0.75;">(viewing {{ tripsView ? 'trips' : 'jobs' }})</span>
    </div>

    <hr style="margin: 0px;">


    <div style="max-width: 100%; height:100%;
    overflow-x: scroll;">
    <p *ngIf="(job$ | async)?.length == 0 && !(jobLoading$ | async)" style="font-size: 20px;text-align: left;"> (No Jobs added for this location yet) </p>
    <p *ngIf="tripsView && hasNoVisibleJobs(job$ | async, true) && !(jobLoading$ | async)" style="font-size: 20px;text-align: left;"> (No trips for this location yet) </p>
    <p *ngIf="!tripsView && hasNoVisibleJobs(job$ | async, false) && !(jobLoading$ | async)" style="font-size: 20px;text-align: left;"> (No regular jobs - all jobs are trips) </p>
    <div *ngIf="jobLoading$ | async"><p>Loading...</p><mat-spinner></mat-spinner></div>
    <div fxLayout="row" fxLayout.xs = "column" style="padding:5px;">

      <div *ngFor = "let job of (job$ | async); " class="jobBlock" style="min-width: 300px; max-width: 300px;padding: 10px;
      margin-bottom: 9px;
      border-radius: 13px;" [ngStyle]="{'background-color': job.istrip ? 'white' : ''}"
      [hidden]="tripsView ? !job.istrip : job.istrip">

        <div class="job-top-section">
          <div id="main-job">



        <h5 style="font-size: 1.1rem; font-weight: 600; overflow-wrap: anywhere; word-break: break-word;"><u>{{job.customer_name ? job.customer_name.trim() : ''}} - {{job.customer_jobtype ? job.customer_jobtype.trim() : ''}}</u>
          <button button mat-icon-button title="delete" (click)="deleteJob(job, row)"><fa-icon [icon]="fatrash" style="color: red"></fa-icon></button>


          <p *ngIf="!job.isaudit && !job.istrip">

            <span>  <span style="padding-right: 5px;font-weight: 200;">EPO?</span><mat-checkbox [(ngModel)]="job.eporeqstd"
            [color]="job.eporeqstd"
            (ngModelChange)="epoUpdated(job)" [style.background]="job.eporeqstd ? 'aqua': 'grey'"></mat-checkbox></span></p>
          <p *ngIf="job.isaudit">Audit</p>

        </h5>


        <h4 style="font-size: 16px;"><i>{{job.name}}</i></h4>
        {{job.schedule_date ? ( job.schedule_date.substring(5,7) + '/' + job.schedule_date.substring(8,10) + '/' + job.schedule_date.substring(0,4)) : '' }}
        <p *ngIf="job.job_status && !job.job_status.toLowerCase().includes('fail') && !job.job_status.toLowerCase().includes('projected')" style= "color:green;">{{job.job_status}}</p>
        <p *ngIf="job.job_status && job.job_status.toLowerCase().includes('projected')" style="color:rgb(255, 0, 0);">{{job.job_status}}</p>

        <p>

          <button class="blink_me" mat-icon-button *ngIf="job.job_status !== null && job.job_status.toLowerCase().includes('fail')" (click)="openFailNotes(job)">{{job.job_status}}</button>
        </p>

          </div>

          <div *ngIf="job.istrip" id='tripDetails'>
            <div *ngIf="getTripDetails(job).length > 0">
              <h5 style="font-size: 1.1rem; font-weight: 600; margin-bottom: 10px;">Trip Jobs:</h5>
              <div *ngFor="let tripDetail of getTripDetails(job)">
                <p class="trip-task-link" style="margin: 5px 0; overflow-wrap: anywhere; word-break: break-word;"
                  title="Edit this task" (click)="openEditJob(tripDetail.job, row, !!tripDetail.job.isaudit)">
                  <fa-icon *ngIf="tripDetail.completed" [icon]="facheckcircle"
                    [title]="tripDetail.status" style="color: #2e7d32; margin-right: 6px;"></fa-icon>
                  <fa-icon *ngIf="!tripDetail.completed && tripDetail.failed" [icon]="faexclamationtriangle"
                    [title]="tripDetail.status" style="color: #d32f2f; margin-right: 6px;"></fa-icon>
                  <fa-icon *ngIf="!tripDetail.completed && !tripDetail.failed" [icon]="faexclamationtriangle"
                    [title]="tripDetail.status || 'Needs attention'" style="color: #9e9e9e; margin-right: 6px;"></fa-icon>
                  <span style="text-decoration: underline;">{{tripDetail.jobType}}</span>
                  <fa-icon [icon]="faedit" style="margin-left: 6px; font-size: 0.85em; opacity: 0.6;"></fa-icon>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div id="common-info">
        Assigned to : {{job.employee_name ? job.employee_name.trim() : ''}} {{job.supervisorname ? '- (' + job.supervisorname.trim() + ')' : '' }} <br>


          <button *ngIf = 'job.isaudit' button mat-icon-button title="Edit Audit Job" (click)="openEditJob(job,row,true)" style="color: white"><fa-icon [icon]="faedit"></fa-icon></button>
          <button *ngIf = '!job.isaudit' button mat-icon-button title="edit" (click)="openEditJob(job,row)"><fa-icon [icon]="faedit"></fa-icon></button>

          <button *ngIf='!job.email_sent' button mat-icon-button title="send results email" (click)="sendResultsEmail(job,row)" ><fa-icon [icon]="faenvelope" style="color: #424242"></fa-icon></button>
          <button *ngIf='job.email_sent' button mat-icon-button title="results email sent!" (click)="sendResultsEmail(job,row)" ><fa-icon [icon]="faenvelope" style="color: #8cc63f"></fa-icon></button>

          <button *ngIf = 'job.form_id && job.schedule_date < "2024-02-22" ' button mat-icon-button title="Open Rater Form" (click)="openJobForm(job)"><fa-icon [icon]="faclipboard" style="color: #599c46"></fa-icon></button>
          <button button mat-icon-button title="Job Photos" (click)="onPhotosClick(job, row)"><fa-icon [icon]="facamera" style="color: #424242"></fa-icon></button>
          <button *ngIf = 'job.form_id' button mat-icon-button title="Get form logs" (click)="onLogClick(job)"><fa-icon [icon]="faScroll" style="color: #424242;"></fa-icon></button>
          <button  button mat-icon-button title="Copy this Job" (click)="copyJob(job, row)"><fa-icon [icon]="fahvac" style="color: #424242;"></fa-icon></button>
          <button  button mat-icon-button title="Note Additional Work" (click)="additionalWork(job, row)"><fa-icon [icon]="fasquare" style="color: #424242;"></fa-icon></button>

          <p *ngIf="job.job_notes">Job Notes: {{job.job_notes}}</p>

          <p *ngIf="job.billing_note" style="word-wrap: break-word;
          font-size: 16px;
          font-weight: 600;
          letter-spacing: 0.25px;
          font-family: sans-serif;">Billing Notes: {{job.billing_note}}</p>

          <p *ngIf="job.customer_jobtype !== null && job.customer_jobtype.toLowerCase().includes('final') && row.track != 1 ">Final Notes: {{job.finalnotes4builder || "no notes"}}</p>

          <div id="tags">
            <div *ngFor="let tag of job.namedTags; let i = index" style="display: inline-block; margin-right: 5px;">
              <button style="background: #3f3f3f;
              color: white;
              border: 0px;
              border-radius: 14px;">{{tag}}</button>
            </div>
          </div>

          <div style="margin-top: 20px;" id="timeButtons" *ngIf="timefunctions">
            <button class="clock"  *ngIf="(job.clockedin == false || job.clockedin == null || !isParticipant(job.participants, employeeID)) && !isPaused" [disabled]="areTimeButtonsDisabled" (click)="updateStartTimeNew(job)"  style="width: 3em;
            /* border: 0; */
            border-color: #dfdfdf;
            border-radius: 1em;
            height: 40px;
            background: #d3d3d3;"><i style="color: #8cc63f;font-size: 24px;" class="fa fa-solid fa-clock"></i></button>
            <button class="clock active" *ngIf="job.clockedin == true || isParticipant(job.participants,employeeID)" [disabled]="areTimeButtonsDisabled" style="
                width: 3em;
                /* border: 0; */
                border-color: #dfdfdf;
                border-radius: 1em;
                height: 40px;
                background: #d3d3d3;"  (click)="updateEndTimeNew(job)"><i class="fa fa-solid fa-clock" style="color: red;font-size: 24px;"></i></button>
          </div>
        </div>

      </div>
    </div>
  </div>


  </div>

  <div [hidden]="show == 1" class ="fade-in" style="background-color: lightgray" >
    <h4>Photos for {{row.street_address}}</h4>
    <hr>
  <div fxLayout="row" fxLayout.xs = "column">
      <div style="height: 300px; width: 300px; padding-right: 2px">
          <mat-card>
              <mat-card-header>
                <mat-card-title>Front </mat-card-title>
                <mat-card-subtitle>Front Elevation</mat-card-subtitle>
              </mat-card-header>
              <img mat-card-image src={{row.elevfront}} alt="Photo not found">
            </mat-card>
      </div>

      <div style="height: 300px; width: 300px; padding-right: 2px">
          <mat-card>
              <mat-card-header>
                <mat-card-title>Left </mat-card-title>
                <mat-card-subtitle>Left Elevation</mat-card-subtitle>
              </mat-card-header>
              <img mat-card-image src={{row.elevleft}} alt="Photo not found">
            </mat-card>
      </div>

      <div style="height: 300px; width: 300px; padding-right: 2px">
          <mat-card>
              <mat-card-header>
                <mat-card-title>Back </mat-card-title>
                <mat-card-subtitle>Back Elevation</mat-card-subtitle>
              </mat-card-header>
              <img mat-card-image src={{row.elevback}} alt="Photo not found">
            </mat-card>
      </div>

      <div style="height: 300px; width: 300px;">
          <mat-card>
              <mat-card-header>
                <mat-card-title>Right </mat-card-title>
                <mat-card-subtitle>Right Elevation</mat-card-subtitle>
              </mat-card-header>
              <img mat-card-image src={{row.elevright}} alt="Photo not found">
            </mat-card>
      </div>



    </div>
   </div>

</ng-template>

<a mat-raised-button href="/m/blackoutdates" target="_blank" style="margin-left: 10px;
box-shadow: none;
border: 0;
background: #424242;
color: aliceblue;
text-decoration: none;
padding: 6px 16px;
margin-right: 2em; 
font-size: 14px;
border-radius: 4px;
cursor: pointer;">Blackout Dates</a>
<a href="/m/drhcltcontacts" target="_blank" rel="noopener" style="margin-left: 10px; color: #424242; font-size: 14px; text-decoration: underline; cursor: pointer;">DRH CLT Contacts</a>



<button mat-button color="primary" (click)="topFunction()" id="topBtn" title="Go to top">Top</button>
</div>

<!-- Chat Widget -->
<button class="chat-trigger" type="button" [class.open]="chatOpen" (click)="toggleChat()">
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
  </svg>
</button>

<div class="chat-panel" [class.open]="chatOpen">
  <div class="chat-header">
    <div class="header-title">
      <span class="header-dot"></span>
      PP Data Assistant
    </div>
    <div class="header-subtitle"><div style="font-weight: 600;">Ask about jobs, HERS scores, trends &amp; more</div>
    <div style="font-style: italic">
      <span>As an early-stage technology, this chat can generate output that seems plausible but is factually incorrect. We recommend that you validate all output.</span>
    </div>
    </div>
    <button class="close-btn" type="button" (click)="toggleChat()">&#10005;</button>
  </div>

  <div class="chat-messages" #chatMessagesEl>
    <div *ngFor="let msg of chatHistory" class="msg" [ngClass]="msg.role">
      <div class="msg-bubble">{{ msg.content }}</div>
      <div *ngIf="msg.role === 'assistant'" class="msg-feedback" [class.voted]="msg.feedback !== undefined">
        <button type="button" title="Helpful"
                [class.selected-up]="msg.feedback === 1"
                (click)="sendChatFeedback(msg, 1)">
          <fa-icon [icon]="faThumbsUp"></fa-icon>
        </button>
        <button type="button" title="Not helpful"
                [class.selected-down]="msg.feedback === -1"
                (click)="sendChatFeedback(msg, -1)">
          <fa-icon [icon]="faThumbsDown"></fa-icon>
        </button>
      </div>
      <div *ngIf="msg.feedback === -1 && !msg.feedbackNoteSent" class="feedback-note">
        <input type="text" 
           [(ngModel)]="msg.feedbackNote" 
           placeholder="What went wrong?" 
           (keydown.enter)="sendFeedbackNote(msg)"
           class="feedback-note-input" />
        <button (click)="sendFeedbackNote(msg)" class="feedback-note-btn">Send</button>
      </div>
    </div>
    <div *ngIf="chatLoading" class="msg assistant">
      <div class="msg-bubble">
        <div class="loading-dots"><span></span><span></span><span></span></div>
      </div>
    </div>
  </div>

  <div class="suggestions" *ngIf="!chatHasSentMessage">
    <button class="suggestion-chip" type="button" (click)="sendChatSuggestion('Top subdivisions by HERS')">Top subdivisions by HERS</button>
    <button class="suggestion-chip" type="button" (click)="sendChatSuggestion('Jobs completed this month')">Jobs completed this month</button>
    <button class="suggestion-chip" type="button" (click)="sendChatSuggestion('Busiest raters this year')">Busiest raters this year</button>
    <button class="suggestion-chip" type="button" (click)="sendChatSuggestion('Job trends by customer')">Job trends by customer</button>
  </div>

  <div class="chat-input">
    <textarea #chatInputEl placeholder="Ask about your data..." rows="1"
              [(ngModel)]="chatInputText"
              [ngModelOptions]="{standalone: true}"
              (keydown)="handleChatKey($event)"
              (input)="autoResizeChatInput()"></textarea>
    <button class="send-btn" type="button"
            [disabled]="!chatInputText.trim() || chatLoading"
            (click)="sendChatMessage()">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="22" y1="2" x2="11" y2="13"></line>
        <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
      </svg>
    </button>
  </div>
</div>
